import * as filter from "./filters";
const pricingRules = require('./pricingRules');
import moment from "moment"

let USER_TYPE;
const DEFAULT_VAT_RATE = 0.2;
function organiseOrders(orders, userType, networks) {
  USER_TYPE = userType;
  return orders
    .map((order) => returnOrganisedOfferItem(order, networks))
    .flat();
}

// Also polyfill Array.isArray:
if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
  };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat#Polyfill
if (!Array.prototype.flat) {
  Array.prototype.flat = function (depth) {
    var flattened = [];
    (function flat(array, depth) {
      for (var i = 0; i < array.length; i++) {
        var el = array[i];
        if (Array.isArray(el) && depth > 0) {
          flat(el, depth - 1);
        } else {
          flattened.push(el);
        }
      }
    })(this, Math.floor(depth) || 1);
    return flattened;
  };
}

function returnOrganisedOfferItem(order, networks) {
  const offers = [];
  for (let i = 0; i < order.offers.length; i++) {
    let totalExVat;
    const currentOffer = order.offers[i];
    const organisedItem = {
      _id: order._id,
      offerId: currentOffer._id,
      collectionTime: currentOffer.collectionTime,
      edited: order.edited,
      orderId: `${order.orderId}-${i + 1}`,
      date: filter.standardDateFormat(order.created),
      reference: order.client_reference,
      premium: currentOffer.premium,
      deliveryDate: order.deliveryDate,
      // required fields for edit order
      vat: order.vat,
      created: order.created,
      status: order.status,
      orderCancelled: order.cancelled,
      lineItemCancelled: currentOffer.lineItemCancelled != undefined,
      fuelType: currentOffer.fuel.type,
      adjustment: currentOffer.adjustment ? currentOffer.adjustment : 0,
      contractNumber: currentOffer.contractNumber,
      releaseNumber: currentOffer.releaseNumber,
      movementNumber: currentOffer.movementNumber,
      orderNotes: order.orderNotes,
      liftingPeriod: getLiftingPeriod(currentOffer, order.created),
    };
    if (order.offers.length > 1) organisedItem.originalOrderId = order.orderId;

    if (order.location) {
      //Delivered In specific stuff
      organisedItem.delivery_location = order.location.name;
      organisedItem.offer_type = "Delivered In";
      organisedItem.deliveryDate = filter.dateFormat(order.deliveryDate) || "N/A";
      organisedItem.ISODeliveryDate = order.deliveryDate;
      organisedItem.exrack = order.haulageRate ? filter.priceFormat(Number(currentOffer.price)) : "N/A";
      organisedItem.haulage = order.haulageRate ? filter.priceFormat(order.haulageRate) : "N/A";
      organisedItem.price = filter.priceFormat(currentOffer.price + order.haulageRate);
      organisedItem.offerTotal = filter.priceFormat(
        ((currentOffer.price + order.haulageRate) * currentOffer.quantityOrdered) / 100
      );
      totalExVat = order.offers.reduce((total, { price, quantityOrdered, lineItemCancelled }) => {
        if (lineItemCancelled) {
          return total;
        }
        return total + Number((((price + order.haulageRate) * quantityOrdered) / 100).toFixed(2));
      }, 0);
    } else {
      //Normal Offer order stuff
      organisedItem.delivery_location = "N/A";
      organisedItem.deliveryDate = "N/A";

      if (currentOffer.type_id === "SETTLEMENT" && !order.settledAt) {
        organisedItem.price = "Pending Settlement";
        organisedItem.offerTotal = "—";
      } else {
        organisedItem.price = filter.priceFormat(currentOffer.price);
        organisedItem.offerTotal = filter.priceFormat((currentOffer.price * currentOffer.quantityOrdered) / 100);
      }
      totalExVat = order.offers.reduce((total, { price, quantityOrdered, lineItemCancelled, type_id }) => {
        if (lineItemCancelled || (type_id === "SETTLEMENT" && !order.settledAt)) {
          return total;
        }
        return total + Number(((price * quantityOrdered) / 100).toFixed(2));
      }, 0);
    }
    const vatRate = order.vat ? order.vat : DEFAULT_VAT_RATE;
    const vatCost = vatRate * totalExVat;
    const totalIncVat = vatCost + totalExVat;

    const hasUnsettledOffers = order.offers.some((o) => o.type_id === "SETTLEMENT" && !order.settledAt);
    organisedItem.totalIncVat = hasUnsettledOffers ? "—" : filter.priceFormat(totalIncVat);
    organisedItem.vatCost = hasUnsettledOffers ? "—" : filter.priceFormat(vatCost);
    organisedItem.totalExVat = hasUnsettledOffers ? "—" : filter.priceFormat(totalExVat);
    organisedItem.credit_days = currentOffer.credit ? filter.creditDaysFormat(currentOffer.credit.days) : "N/A";
    organisedItem.fuel = !currentOffer.terminal ? "Network" : filter.fuelType(currentOffer.fuel_id);
    organisedItem.product_id = currentOffer.fuel_id;
    organisedItem.bioPrice = currentOffer.fuel.type === "NOT4SALE" ? "Split" : "Straight";

    organisedItem.pricingMethod = filter.pricingMethod(currentOffer.type_id);
    organisedItem.type_id = currentOffer.type_id;
    organisedItem.settledAt = order.settledAt || null;
    organisedItem.quantity = filter.volumeFormat(currentOffer.quantityOrdered);
    organisedItem.offer_type = filter.offerType(currentOffer.isContract ? currentOffer.isContract : false);
    organisedItem.measurement = filter.fuelMeasurementType(currentOffer.fuel_measurement_id);

    organisedItem.product_type = filter.storageType(currentOffer.storage_type_id);
    organisedItem.terminal = getOfferTerminalName(currentOffer, networks);
    organisedItem.account = getRelevantAccountName(order);

    organisedItem.seller = currentOffer.seller;
    organisedItem.buyer = order.buyer;
    organisedItem.basket_id = order.basket_id;

    organisedItem.bunkeringAccountNumber = getBunkeringAccountNumber(organisedItem, order, i);

    organisedItem.pricingEngineEnabled = currentOffer.pricingEngineEnabled;
    if (currentOffer.pricingEngineEnabled) organisedItem.pricingAuditTrail = currentOffer.pricingAuditTrail;

    const { contractNumber, releaseNumber, movementNumber } = getHarvestOrderNumbers(currentOffer._id, order);

    if (contractNumber) {
      organisedItem.contractNumber = contractNumber;
      organisedItem.orderNumber = contractNumber;
    }

    if (releaseNumber) {
      organisedItem.releaseNumber = releaseNumber;
    }

    if (movementNumber) {
      organisedItem.movementNumber = movementNumber;
    }

    offers.push(organisedItem);
  }
  return offers;
}

function getHarvestOrderNumbers(offerId, { contractNumbers, pickupNumbers, liftingNumbers }) {
  let contractNumber, releaseNumber, movementNumber;
  if (contractNumbers && contractNumbers.length > 0) {
    const c = contractNumbers.find((item) => item.offerId === offerId);
    contractNumber = c ? c.referenceNumber : null;
  }

  if (pickupNumbers && pickupNumbers.length > 0) {
    const r = pickupNumbers.find((item) => item.offerId === offerId);
    releaseNumber = r ? r.referenceNumber : null;
  }

  if (liftingNumbers && liftingNumbers.length > 0) {
    const l = liftingNumbers.find((item) => item.offerId === offerId);
    movementNumber = l ? l.referenceNumber : null;
  }
  return { contractNumber, releaseNumber, movementNumber };
}

function getOfferTerminalName(offer, networks) {
  if (offer.networkId && networks) {
    const network = networks.find((n) => n._id === offer.networkId);
    return network ? network.name : "N/A";
  } else if (offer.network_id) {
    // @TO-DO: Remove the following condition after orders have been updated with networkId
    if (offer.network_id === "KEY") return "Keyfuels";
    return "UK Fuels";
  } else if (offer.fuel.name === "UK Fuels") return "UK Fuels";
  else if (offer.fuel.name === "Keyfuels") return "Keyfuels";
  return offer.terminal.name;
}

function getRelevantAccountName(order) {
  if (USER_TYPE === "buyer") {
    if (order.offers && order.offers[0]) {
      return order.offers[0].seller.name;
    } else {
      return "N/A";
    }
  } else {
    if (order.buyer) {
      return order.buyer.name;
    } else {
      return "N/A";
    }
  }
}

function filterPricingRulesForOrderReceipt(orderItem, marketWindow, productIds, auditTrailType) {
  switch (auditTrailType) {
    case "MARKET_DATA":
      return pricingRules.getMarketDataOrderRules(orderItem, marketWindow, productIds);
    case "PRODUCT_SPECIFIC": {
      return pricingRules.getProductSpecificRules(orderItem, productIds);
    }
    default: {
      return [
        ...pricingRules.getMarketDataOrderRules(orderItem, marketWindow, productIds),
        ...pricingRules.getProductSpecificRules(orderItem, productIds),
      ];
    }
  }
}

function getBunkeringAccountNumber(organisedItem, order, orderItemIndex) {
  // Applies to spot bunkering offers only
  if (organisedItem.product_type !== "Bunkering" || organisedItem.offer_type === "Contract") {
    return "-";
  }
  if (order.offers[orderItemIndex].offerReference != null) {
    return order.offers[orderItemIndex].offerReference;
  }
  if (organisedItem.reference.includes(";") && order.offers.length > 1) {
    // For legacy multi-offer orders where the order reference was an aggregation of the individual acc references
    return organisedItem.reference.split(";")[orderItemIndex];
  }

  return organisedItem.reference; //For legacy single offer orders where the acc reference was the order reference
}

function getLiftingPeriod(offer, orderCreated = null) {
  if (!offer.terminal_id) {
    return [];
  }
  if (offer.liftingPeriod && offer.liftingPeriod.length === 2) {
    return offer.liftingPeriod;
  }
  return convertCollectionTimeToLiftingPeriod(offer.collectionTime, orderCreated);
}

function getOrderStatusDisplay(order, page = "") {
  const orderStatusObject = {
    text: "",
    textColor: "",
    showEditOptionOnly: false,
  };
  const showCancelled = order.orderCancelled || (page === "purchaseHistory" && order.lineItemCancelled);
  if (showCancelled) {
    orderStatusObject.text = "Order Cancelled";
    orderStatusObject.textColor = "t_red";
    if (page === "purchaseHistory") {
      orderStatusObject.text = "Cancelled";
    }
  } else {
    orderStatusObject.text = order.status === "INCOMPLETE" ? "Pending Confirmation" : "Order Confirmed";
    orderStatusObject.textColor = orderStatusObject.text === "Pending Confirmation" ? "t_orange" : "t_green";
    if (page === "purchaseHistory") {
      orderStatusObject.text = orderStatusObject.text === "Pending Confirmation" ? "Pending" : "Confirmed";
    }
  }
  if (orderStatusObject.text === "Confirmed") {
    orderStatusObject.showEditOptionOnly = true;
  }
  return orderStatusObject;
}

function convertCollectionTimeToLiftingPeriod(collectionTime, date = null) {
  let timePeriod1, timePeriod2;
  switch (collectionTime) {
    case 0:
      timePeriod1 = moment.parseZone(date);
      timePeriod2 = moment.parseZone(date);
      break;
    case 1:
      timePeriod1 = moment.parseZone(date).add(1, "days");
      timePeriod2 = moment.parseZone(date).add(1, "days");
      break;
    case 2:
      timePeriod1 = moment.parseZone(date).add(2, "days");
      timePeriod2 = moment.parseZone(date).add(2, "days");
      break;
    case 30:
      timePeriod1 = moment.parseZone(date);
      timePeriod2 = moment.parseZone(date).add(30, "days");
      break;
    default:
      timePeriod1 = moment.parseZone(date);
      timePeriod2 = moment.parseZone(date).add(collectionTime - 1, "days");
  }
  return [timePeriod1, timePeriod2];
}

export {
    organiseOrders,
    filterPricingRulesForOrderReceipt,
    getOrderStatusDisplay
};